import { Typography, Box, CardContent, Card } from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";
import { PLAN_CONFIG } from "services/sosInventoryService/trial/schema";

export function PlanCard(props) {
  const { name, priceMonthly, userLimit, extraUserMonthly, search } = props;

  const planConfig = PLAN_CONFIG[name];

  const priceString1 = `$${priceMonthly} / `;
  const priceString2 = `${i18n("accountInformation.month")}`;

  function getLinkUrl() {
    // start with the current query string
    const params = new URLSearchParams(search);

    // Add or update the `plan` param
    params.set("plan", name);
    return `/trialsignup?${params.toString()}`;
  }

  return (
    <Card
      variant="outlined"
      sx={{
        display: "grid",
        gridTemplateRows: "auto 1fr auto",
        width: "20rem",
        p: "1rem 0",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 0, alignItems: "center" }}>
        <Typography component="span" variant="h4">
          {name}
        </Typography>
        <Typography sx={{ ml: 1 }} component="span">
          {planConfig.subTitle}
        </Typography>
      </Box>
      <CardContent sx={{ pt: 0 }}>
        <ul style={{ paddingLeft: "1rem" }}>
          {planConfig?.bullets.map((bullet, i) => (
            <li key={i}>{bullet}</li>
          ))}
          <li>
            {userLimit} {i18n("accountInformation.usersIncluded")} $
            {extraUserMonthly} {i18n("accountInformation.eachAdditionalUser")}
          </li>
        </ul>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <Typography variant="h4">{priceString1}</Typography>
          <Typography sx={{ ml: "0.25rem" }}>{priceString2}</Typography>
        </Box>
      </CardContent>
      <Box
        sx={{ textAlign: "center", martinTop: "auto", pl: "16px", pr: "16px" }}
      >
        <div style={{ position: "relative" }}>
          <Link to={getLinkUrl()}>
            <ActionButton size="large" sx={{ martinTop: "auto" }}>
              {`${i18n("accountInformation.Choose")} ${name}`}{" "}
            </ActionButton>
          </Link>
        </div>
      </Box>
    </Card>
  );
}
